import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, FormGroup, Input, Form } from 'reactstrap';
import { resetPassword } from '../actions/Users';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';

import utils from '../lib/utils';

const loginBoxStyle = {
  top: '200px',
  position: 'relative',
  backgroundColor: '#eee',
  padding: '50px 50px',
  borderRadius: '5px',
  boxShadow: '5px 3px 10px 3px #e95858',
};

const containerStyle = {
  height: '100vH',
  backgroundImage: 'linear-gradient(180deg,rgba(255,67,67,0.93) 0%,#fd8233 100%)', // Epik Website gradient
};

const NewPassword = ({ resetPassword }) => {
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [message, setMessage] = useState('');
  const [addPass, setAddPass] = useState(false);
  const [count, setCount] = useState(10);

  useEffect(() => {
    if (message !== '' && count > 1) {
      const timer = setTimeout(() => setCount(count - 1), 1000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [message, count]);
  const link = window.location.pathname.split('/');
  const linkMode = link[link.length - 1];

  const onSubmit = async e => {
    e.preventDefault();
    if (utils.validateOnlyPassword(newPassword)) {
      if (newPassword === repeatNewPassword) {
        try {
          const email = localStorage.getItem('email');
          setNewPassword('');
          setRepeatNewPassword('');
          await resetPassword(email, newPassword, linkMode);
          setMessage(
            'Password has been successfully changed, now you can follow the link below and enter new data or you will be automatically transferred to the registration page in',
          );
          setTimeout(function () {
            setAddPass(true);
          }, 10000);
          localStorage.clear();
        } catch (error) {
          if (error.response.data.includes('Cannot use an old password')) {
            setErrorMessage('You cannot use your previous password. Please choose a new password.');
          }
          else {
            setErrorMessage(error.response.data);
            setMessage('');
          }
        }
      } else {
        setErrorMessage('New password and its confirmation do not match. Please, re-enter!');
      }
    } else {
      setErrorMessage(
        'Incorrect password combination, please follow the instructions.',
      );
    }
  };
  return (
    <div style={containerStyle}>
      <div className="container">
        <div className="row mx-auto" style={loginBoxStyle}>
          <div className="col-6 text-left">
            {message ? (
              !errorMessage ? (
                <>
                  <h1 className="text-primary">Excellent</h1>
                  <span style={{ color: '#17a2b8' }}>
                    {message} {count} seconds
                  </span>
                  {addPass && <Redirect to="/login" />}
                  <div>
                    <Link to="/login">To login</Link>
                  </div>
                </>
              ) : (
                <>
                  <h1 className="text-primary">Something wrong</h1>
                  <span style={{ color: '#17a2b8' }}>
                    Try entering the <Link to="/reset-password">email again.</Link>
                  </span>
                </>
              )
            ) : (
              <>
                <h1 className="text-primary">New password</h1>
                <p className="text-info">Please enter your new password to your Epik&trade; Dashboard</p>
                <Form id="newPassUser" onSubmit={onSubmit}>
                  <FormGroup>
                    <Input
                      type="password"
                      value={newPassword}
                      onChange={({ currentTarget }) => setNewPassword(currentTarget.value.trim())}
                      onFocus={() => setErrorMessage('')}
                      autoComplete="new-password"
                      placeholder="Enter your new password"
                      id="new-reset-password"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="password"
                      value={repeatNewPassword}
                      onChange={({ currentTarget }) =>
                        setRepeatNewPassword(currentTarget.value.trim())
                      }
                      onFocus={() => setErrorMessage('')}
                      autoComplete="new-password"
                      placeholder="Repeat your new password"
                      id="repeat-reset-password"
                    />
                  </FormGroup>
                </Form>
                {errorMessage && (
                  <div style={{ color: 'red', fontSize: '11px' }}>
                    {errorMessage}
                  </div>
                )}
                <span style={{ color: '#3b5aa9', fontSize: '11px' }}>Note: Password must contain at least 8 characters, including at least one number, one uppercase letter, one lowercase letter and one special character.</span>
                <FormGroup className="text-right">
                  <Button
                    color="primary"
                    style={{ marginTop: '10px' }}
                    type="submit"
                    form="newPassUser"
                    id="update-password"
                  >
                    Update Password
                  </Button>
                </FormGroup>
              </>
            )}
          </div>
          <div className="col-3" style={{ margin: 'auto' }}>
            <EpikLogoSvg width={120} height={60} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  resetPassword: (email, password, link) => dispatch(resetPassword(email, password, link)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewPassword);
